import sendLocalRequest from "./sendLocalRequest";

export const getMachineErrorsArchive = (auth_token, uniqueId) => {
    return  new Promise( (resolve, reject) => {
        sendLocalRequest(`machines/${uniqueId}/errors_archive`, "GET", auth_token).then( (data) => {
            resolve(data);
        }).catch( (error) => {
            reject(error);
        })
    });



};
